import { REMOVE_TOKEN_SYSTEM } from "./../shared/constants";

export const LoginMSSO = async (msalInstance) => {
    let response = { success: true, data: {} }; 
    try {
        // Iniciar sesión utilizando MSAL
        const loginResponse = await msalInstance.loginPopup();
        response.data.mail = loginResponse?.account?.username;
        response.data.accessToken = loginResponse?.idToken;

    } catch (error) {
        response.success = false;

        // Si es error de interacción en progreso, informa al usuario
        if (error.errorCode === "interaction_in_progress" ||
            (error.message && error.message.includes("interaction_in_progress"))) {
            response.message = "Ya hay una ventana de inicio de sesión abierta. Por favor, complete el proceso en esa ventana.";
        } else if (error.errorCode === "user_cancelled") {
            response.message = "El proceso de inicio de sesión fue cancelado. Por favor, intenta nuevamente.";
        } else { 
            response.message = "Ocurrió un error inesperado.";
        }
    }
    return response;
};
export const LogoutMSSO = async (msalInstance, accounts) => {
    let response = { success: true };
    // Verificar si la instancia de MSAL está inicializada
    if (!msalInstance) {
        console.error("La instancia de MSAL no está inicializada.");
        return { success: false, message: "La instancia de MSAL no está inicializada." };
    }

    try {
        await msalInstance.logoutRedirect({
            account: accounts[0],
        }); 
        // Eliminar el token del sistema
        REMOVE_TOKEN_SYSTEM();
    } catch (error) {
        console.error("Error al cerrar sesión:", error);
        response = { 
            success: false, 
            message: "Ocurrió un error al cerrar la sesión. Por favor, inténtalo de nuevo." 
        };
    }

    return response;
}; 